// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.winner[data-v-4ccf2ba3] {\r\n  background-color: rgb(0, 255, 0, 0.2);\n}\n.loser[data-v-4ccf2ba3] {\r\n  background-color: rgb(255, 0, 0, 0.2);\n}\n.notedate[data-v-4ccf2ba3] {\r\n  font-size: 11px;\n}\r\n", ""]);
// Exports
module.exports = exports;
